import React from 'react';
import style from '../css/Services.module.css';
import { Service_list } from '../data/Service_List';
import useLocation from './useLocation';
import { Service_list_bang } from '../data/Service_List_bang';

function Service_list_com() {
	const location = useLocation();
	return (
		<div>
			<p className={style.list}>List Of Our Services</p>
			<div className={style.container}>
				{location === 'Bangalore'
					? Service_list_bang.map((service, index) => (
							<div key={service.id} className={style.container1}>
								<img
									src={service.img}
									alt={service.title}
									className={style.image}
								/>
								<div className={style.text_box}>
									<h2 className={style.title}>{service.title}</h2>
									<p className={style.desc}>{service.desc}</p>
								</div>
							</div>
					  ))
					: Service_list.map((service, index) => (
							<div key={service.id} className={style.container1}>
								<img
									src={service.img}
									alt={service.title}
									className={style.image}
								/>
								<div className={style.text_box}>
									<h2 className={style.title}>{service.title}</h2>
									<p className={style.desc}>{service.desc}</p>
								</div>
							</div>
					  ))}
			</div>
		</div>
	);
}

export default Service_list_com;
